import React from 'react';

import DataSource from 'services/DataSource';
import { expertDefaultSearchState } from 'services/constants';

import AbstractSearchForm from 'components/AbstractSearchForm';
import Autocomplete       from 'components/autocomplete';


export default class ExpertSearchForm extends AbstractSearchForm {

  constructor(props) {
    super(props);
    this.defaultSearchState = expertDefaultSearchState;
    this.state.countries = [];
  }

  getSeachData() {
    const resource = DataSource.getSource('countries', 'countries{/:id}.json', 'country');
    resource.query({with_experts: true}).then((data) => {
      if (this.mounted) {
        this.setState( { countries: data.items } );
      }
    });
  }

  render() {
    const item = this.state.item;
    if (Object.keys(item).length < 1) return null;
    return (
      <form onSubmit={this.onSubmit} className="col-md-8 border p-3 rounded">
        <div className="row">
          <div className="col-sm-3">
            <label htmlFor="name">Имя</label>
            <input id="name" name="name" className="form-control" value={item.name} onChange={this.propertyChanged} />
          </div>
          <div className="col-sm-3 mb-3">
            <label htmlFor="country_id">Страна</label>
            <Autocomplete items={this.state.countries} name="country_id" value={item.country_id} 
            getValue={item => item.id} getLabel={item => item.title} onChange={this.propertyChanged} />
          </div>
          <div className="col-sm-3">
            <label htmlFor="email">Email</label>
            <input id="email" name="email" className="form-control" value={item.email} onChange={this.propertyChanged} />
          </div>
          <div className="col-sm-1 ms-4">
            <label style={{width:'100%'}}>&nbsp;</label>
            <button type="submit" className="btn btn-primary">Искать</button>
          </div>
          <div className="col-sm-1">
            <label style={{width:'100%'}}>&nbsp;</label>
            <button onClick={this.clear} type="button" className="btn btn-default">Очистить</button>
          </div>
        </div>
      </form>
    )
  }
}
